export var isLoadingImage = function (mediaType, dataURI) {
    return mediaType === 'image' && !dataURI;
};
//# sourceMappingURL=isLoadingImage.js.map